// import React, { useState, useEffect, useRef } from 'react';
// import { FaPhoneAlt, FaMapMarkerAlt, FaUser, FaTimes, FaBars, FaChevronDown } from 'react-icons/fa';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import Logo from '../Logo/Logo';
// import './Header.css';

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const menuRef = useRef(null);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const menuItems = [
//     { title: 'HOME', path: '/' },
//     { title: 'ABOUT', path: '/about' },
//     { 
//       title: 'ACADEMICS', 
//       path: '/academics',
//       dropdown: true,
      // items: [
      //   { title: 'Business and Management', path: '/academics/business-management' },
      //   { title: 'Marketing', path: '/academics/marketing' },
      //   { title: 'Health and Social Care', path: '/academics/health-social-care' },
      //   { title: 'Psychology', path: '/academics/psychology' },
      //   { title: 'Health and Safety Management', path: '/academics/health-safety-management' },
      //   { title: 'Hospitality and Tourism Management', path: '/academics/hospitality-tourism' },
      //   { title: 'Human Resource Management', path: '/academics/human-resource' },
      //   { title: 'Accounting and Finance', path: '/academics/accounting-finance' },
      //   { title: 'Law and Legal Services', path: '/academics/law-legal' },
      //   { title: 'Information Technology', path: '/academics/information-technology' },
      //   { title: 'Data Science', path: '/academics/data-science' },
      //   { title: 'Cyber Security', path: '/academics/cyber-security' },
      //   { title: 'Logistics and Supply Chain Management', path: '/academics/logistics-supply-chain' },
      //   { title: 'Early Years Education', path: '/academics/early-years-education' },
      //   { title: 'Education and Training', path: '/academics/education-training' },
      //   { title: 'Teaching and Coaching', path: '/academics/teaching-coaching' },
      //   { title: 'Sports Coaching', path: '/academics/sports-coaching' },
      //   { title: 'Aesthetic Practice', path: '/academics/aesthetic-practice' },
      //   { title: 'Beauty Therapy', path: '/academics/beauty-therapy' },
      //   { title: 'Hairdressing', path: '/academics/hairdressing' },
      //   { title: 'Wellness', path: '/academics/wellness' }
      // ]
//     },
//     { 
//       title: 'ADMISSIONS', 
//       path: '/admissions',
//       dropdown: true,
//       items: [
//         { title: 'How to Apply?', path: '/admissions/how-to-apply' },
//         { title: 'Apply Now!', path: '/admissions/apply-now' },
//         { title: 'University Progressions', path: '/admissions/university-progressions' },
//       ]
//     },
//     { 
//       title: 'ONLINE CAMPUS', 
//       path: '/online-campus',
//       dropdown: true,
//       items: [
//         { title: 'About Lawrence Online', path: '/online-campus/about' },
//         { title: 'Why Lawrence Online', path: '/online-campus/why-lawrence' },
//         { title: 'Online Verification', path: '/online-campus/verification' },
//         { title: 'Smart Learning', path: '/online-campus/smart-learning' },
//       ]
//     },
//     { title: 'CENTERS', path: '/centers', className: 'font-semibold text-red-600' },
//     { title: 'CONTACT', path: '/contact' },
//     { title: 'APPLY NOW', path: '/admissions/apply-now', className: '!bg-primary hover:!bg-primary-dark !text-white !px-3 !py-1.5 rounded-md transition-colors text-sm' },
//   ];

//   const [hoverTimeout, setHoverTimeout] = useState(null);

//   const toggleDropdown = (menu, e) => {
//     if (e) {
//       e.preventDefault();
//       e.stopPropagation();
//     }
//     setOpenDropdown(openDropdown === menu ? null : menu);
//   };

//   const handleMouseEnter = (menu) => {
//     if (hoverTimeout) {
//       clearTimeout(hoverTimeout);
//       setHoverTimeout(null);
//     }
//     setOpenDropdown(menu);
//   };

//   const handleMouseLeave = () => {
//     // Add a small delay before closing to allow moving to the dropdown
//     const timeout = setTimeout(() => {
//       setOpenDropdown(null);
//     }, 300);
//     setHoverTimeout(timeout);
//   };

//   const cancelLeave = () => {
//     if (hoverTimeout) {
//       clearTimeout(hoverTimeout);
//       setHoverTimeout(null);
//     }
//   };

//   const handleNavClick = (item, e) => {
//     if (item.dropdown) {
//       e.preventDefault();
//       e.stopPropagation();
//       toggleDropdown(item.title, e);
//       // Navigate to the main item's path when clicked
//       if (!isDropdownOpen(item.title)) {
//         navigate(item.path);
//       }
//     }
//   };

//   const handleDropdownItemClick = (e, path) => {
//     e.stopPropagation();
//     closeAllDropdowns();
//     navigate(path);
//   };

//   const closeAllDropdowns = () => {
//     setOpenDropdown(null);
//     setIsMenuOpen(false);
//   };

//   const isDropdownOpen = (menu) => {
//     return openDropdown === menu;
//   };

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         closeAllDropdowns();
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//       if (hoverTimeout) clearTimeout(hoverTimeout);
//     };
//   }, [hoverTimeout]);

//   // Close dropdowns when route changes
//   useEffect(() => {
//     closeAllDropdowns();
//   }, [location.pathname]);

//   const isHomePage = location.pathname === '/';

//   // Handle scroll effect
//   useEffect(() => {
//     const handleScroll = () => {
//       const offset = window.scrollY;
//       setIsScrolled(offset > 50);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   // Close menu when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // Close menu when route changes
//   useEffect(() => {
//     setIsMenuOpen(false);
//   }, [location]);

//   return (
//     <>
//       {/* Top Bar */}
//       <div className="top-bar">
//         <div className="container">
//           <div className="contact-info">
//             <span className="contact-item">
//               <FaPhoneAlt className="contact-icon" />
//               <a href="tel:+442081234567">+44 20 8123 4567</a>
//             </span>
//             <span className="contact-item">
//               <FaMapMarkerAlt className="contact-icon" />
//               <span>25/2 Barking Enterprise Centre, 50 Cambridge Road, Barking, IG11 8FG</span>
//             </span>
//           </div>
//           <div className="auth-links">
//             <span className="ukrlp">UK Register of learning provider UKRLP:1008774</span>
//             <div className="auth-buttons">
//               <Link to="/login" className="auth-link !text-white">
//                 <FaUser className="auth-icon" />
//                 <span>Login</span>
//               </Link>
//               <span className="divider">|</span>
//               <Link to="/register" className="auth-link !text-white">
//                 <span>Register</span>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Header */}
//       <header className={`main-header ${isScrolled ? 'scrolled' : ''} ${isHomePage ? 'homepage' : ''}`} style={{ minHeight: '80px', display: 'flex', alignItems: 'center', position: 'relative', zIndex: '40', overflow: 'visible' }}>
//         <div className="container" style={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           flexDirection: 'row',
//           width: '100%',
//           justifyContent: 'flex-start',
//           padding: '0 15px',
//           margin: '0 auto',
//           maxWidth: '1200px',
//           gap: '16px'
//         }}>
//           {/* Both logos together, left-aligned */}
//           <Logo />

//           {/* Desktop Navigation */}
//           <div style={{ 
//             flex: '1 1 auto', 
//             display: 'flex', 
//             alignItems: 'center',
//             height: '100%',
//             marginLeft: '16px',
//             paddingLeft: 0,
//             borderLeft: 'none'
//           }}>
//             <nav 
//               ref={menuRef}
//               className={`desktop-nav ${isMenuOpen ? 'mobile-visible' : ''}`}
//               style={{ 
//                 height: '100%', 
//                 display: 'flex', 
//                 alignItems: 'center',
//                 marginLeft: '40px',
//                 width: '100%'
//               }}>
//               <ul className="nav-links" style={{ 
//                 margin: 0, 
//                 padding: '0 0 0 5px', 
//                 display: 'flex',
//                 gap: '12px',
//                 listStyle: 'none',
//                 alignItems: 'center',
//                 height: '100%',
//                 whiteSpace: 'nowrap',
//                 fontSize: '0.95rem'
//               }}>
//               {menuItems.map((item, index) => (
//                 <li 
//                   key={index} 
//                   className={`nav-item ${item.dropdown ? 'has-dropdown' : ''}`}
//                 >
//                   {item.dropdown ? (
//                     <div 
//                       className="nav-dropdown"
//                       onMouseEnter={() => !isMenuOpen && handleMouseEnter(item.title)}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       <div className="nav-link-wrapper">
//                         <Link
//                           to={item.path}
//                           className={`nav-link ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
//                           onClick={(e) => handleNavClick(item, e)}
//                           aria-expanded={isDropdownOpen(item.title)}
//                           aria-haspopup="true"
//                         >
//                           {item.title}
//                           <span 
//                             className="dropdown-icon"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               toggleDropdown(item.title, e);
//                             }}
//                           >
//                             {isDropdownOpen(item.title) ? <FaChevronUp /> : <FaChevronDown />}
//                           </span>
//                         </Link>
//                         <div 
//                           className={`dropdown-menu ${isDropdownOpen(item.title) ? 'show' : ''}`}
//                           onClick={(e) => e.stopPropagation()}
//                           onMouseEnter={cancelLeave}
//                           onMouseLeave={handleMouseLeave}
//                         >
//                           <div className="dropdown-arrow"></div>
//                           <div className="hidden md:flex items-center" style={{ gap: '0.25rem' }}>
//                             {item.items.map((subItem, subIndex) => (
//                               <Link
//                                 key={subIndex}
//                                 to={subItem.path}
//                                 className={`px-2 py-1.5 text-xs font-medium text-gray-700 hover:text-primary transition-colors whitespace-nowrap`}
//                                 onClick={(e) => handleDropdownItemClick(e, subItem.path)}
//                               >
//                                 {subItem.title}
//                               </Link>
//                             ))}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                 ) : (
//                   <Link
//                     to={item.path}
//                     className={`px-2 py-2 text-xs font-medium text-gray-700 hover:text-primary transition-colors whitespace-nowrap ${item.className || ''}`}
//                   >
//                     {item.title}
//                   </Link>
//                 )}
//               </li>
//             ))}
//               </ul>
//             </nav>
//           </div>

//           {/* Mobile Menu Button */}
//           <button 
//             className="mobile-menu-button" 
//             onClick={toggleMenu}
//             aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
//           >
//             {isMenuOpen ? <FaTimes /> : <FaBars />}
//           </button>
//         </div>
//       </header>
//     </>
//   );
// };

// //  export default Header;
// import React, { useState, useEffect, useRef } from 'react';
// import { FaPhoneAlt, FaMapMarkerAlt, FaUser, FaTimes, FaBars, FaChevronDown } from 'react-icons/fa';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import Logo from '../Logo/Logo';

// // Header.css file ab zaroori nahi hai.

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);

//   const location = useLocation();
//   const navigate = useNavigate();
//   const headerRef = useRef(null);

//   const menuItems = [
//     { title: 'HOME', path: '/' },
//     { title: 'ABOUT', path: '/about' },
//     { 
//       title: 'ACADEMICS', 
//       path: '/academics',
//       dropdown: true,
      // items: [
      //   { title: 'Business and Management', path: '/academics/business-management' },
      //   { title: 'Marketing', path: '/academics/marketing' },
      //   { title: 'Health and Social Care', path: '/academics/health-social-care' },
      //   { title: 'Psychology', path: '/academics/psychology' },
      //   { title: 'Health and Safety Management', path: '/academics/health-safety-management' },
      //   { title: 'Hospitality and Tourism Management', path: '/academics/hospitality-tourism' },
      //   { title: 'Human Resource Management', path: '/academics/human-resource' },
      //   { title: 'Accounting and Finance', path: '/academics/accounting-finance' },
      //   { title: 'Law and Legal Services', path: '/academics/law-legal' },
      //   { title: 'Information Technology', path: '/academics/information-technology' },
      //   { title: 'Data Science', path: '/academics/data-science' },
      //   { title: 'Cyber Security', path: '/academics/cyber-security' },
      //   { title: 'Logistics and Supply Chain Management', path: '/academics/logistics-supply-chain' },
      //   { title: 'Early Years Education', path: '/academics/early-years-education' },
      //   { title: 'Education and Training', path: '/academics/education-training' },
      //   { title: 'Teaching and Coaching', path: '/academics/teaching-coaching' },
      //   { title: 'Sports Coaching', path: '/academics/sports-coaching' },
      //   { title: 'Aesthetic Practice', path: '/academics/aesthetic-practice' },
      //   { title: 'Beauty Therapy', path: '/academics/beauty-therapy' },
      //   { title: 'Hairdressing', path: '/academics/hairdressing' },
      //   { title: 'Wellness', path: '/academics/wellness' }
      // ]
//     },
//     { 
//       title: 'UNIVERSITY PROGRESSION', 
//       path: '/university-progression'
//     },
//     { 
//       title: 'Our CAMPUS', 
//       path: '/online-campus',
//       dropdown: true,
//       items: [
//         { title: 'Online Verification', path: '/online-campus/verification' },
//         { title: 'Smart Learning', path: '/online-campus/smart-learning' },
//       ]
//     },
//     { title: 'CENTERS', path: '/centers' },
//     { title: 'CONTACT', path: '/contact' },
//     { title: 'APPLY NOW', path: '/admissions/apply-now' },
//   ];

//   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
//   const toggleDropdown = (e, menuTitle) => { e.preventDefault(); setOpenDropdown(openDropdown === menuTitle ? null : menuTitle); };
//   const closeAllMenus = () => { setIsMenuOpen(false); setOpenDropdown(null); };
//   const handleItemClick = (path) => { navigate(path); closeAllMenus(); };
  
//   useEffect(() => { const handleScroll = () => setIsScrolled(window.scrollY > 50); window.addEventListener('scroll', handleScroll); return () => window.removeEventListener('scroll', handleScroll); }, []);
//   useEffect(() => { closeAllMenus(); }, [location.pathname]);
//   useEffect(() => { const handleClickOutside = (event) => { if (headerRef.current && !headerRef.current.contains(event.target)) { closeAllMenus(); } }; document.addEventListener('mousedown', handleClickOutside); return () => document.removeEventListener('mousedown', handleClickOutside); }, []);
//   useEffect(() => { document.body.classList.toggle('overflow-hidden', isMenuOpen); return () => document.body.classList.remove('overflow-hidden'); }, [isMenuOpen]);

//   return (
//     <header ref={headerRef} className={`bg-white transition-shadow duration-300 z-50 ${isScrolled ? 'fixed top-0 left-0 right-0 shadow-lg ' : 'relative shadow-sm'}`}>
      
//       {/* 
//         FIX 1: MARGIN & WHITESPACE PROBLEM SOLVED
//         -mx-[5%] wali trick hata di hai.
//         Har section ke andar ek 'max-w-screen-xl mx-auto px-5' div hai.
//         Yeh standard aur aazmooda tareeqa hai.
//       */}
      
//       {/* Top Bar */}
//       <div className="bg-brand-dark text-white text-[13px] border-b border-gray-700">
//         <div className="max-w-screen-xl mx-auto px-5">
//             <div className="flex justify-between items-center py-2 flex-wrap gap-x-6 gap-y-2">
//                 <div className="flex items-center gap-5 flex-wrap">
//                     <a href="tel:+442081234567" className="flex items-center gap-2 hover:text-header-primary transition-colors">
//                         <FaPhoneAlt className="text-header-primary" />
//                         <span>+44 20 8123 4567</span>
//                     </a>
//                     <div className="hidden sm:flex items-center gap-2">
//                         <FaMapMarkerAlt className="text-header-primary" />
//                         <span>25/2 Barking Enterprise Centre, Barking, IG11 8FG</span>
//                     </div>
//                 </div>
//                 <div className="flex items-center gap-5">
//                     <span className="text-gray-400 hidden lg:inline">UKRLP: 1008774</span>
//                     <div className="flex items-center gap-2.5 text-sm">
//                         <Link to="/login" className="flex items-center gap-1.5 hover:text-header-primary transition-colors text-white">
//                             <FaUser /><span className=''>Login</span>
//                         </Link>
//                         <span className="text-gray-600">|</span>
//                         <Link to="/register" className="hover:text-header-primary transition-colors ">Register</Link>
//                     </div>
//                 </div>
//             </div>
//         </div>
//       </div>

//       {/* Main Header */}
//       <div className="border-b mr-[11%] border-gray-200/80">
//         <div className="max-w-screen-xl mx-auto px-5">
//             <div className="flex justify-between items-center h-[75px]">
//                 <Link to="/" className="flex-shrink-0" onClick={closeAllMenus}>
//                     <Logo />
//                 </Link>

//                 <nav className="hidden lg:flex items-center h-full">
//                     <ul className="flex items-center h-full gap-1">
//                         {menuItems.map((item) => {
//                             if (item.title === 'APPLY NOW') return null;
//                             return (
//                                 <li key={item.title} className="group relative h-full flex items-center">
//                                     {item.dropdown ? (
//                                         <>
//                                             <Link to={item.path} className="flex items-center gap-2 px-4 h-full text-sm font-semibold uppercase text-gray-700 hover:text-header-primary transition-colors">
//                                                 {item.title}
//                                                 <FaChevronDown className="h-2 w-2 transition-transform group-hover:rotate-180" />
//                                             </Link>
//                                             <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 w-64">
//                                                 <div className="relative bg-white shadow-2xl rounded-lg border border-gray-100">
//                                                     <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-t border-l border-gray-100 rotate-45"></div>
//                                                     <ul className={`p-2 overflow-y-auto scrollbar-hide ${item.title === 'ACADEMICS' ? 'max-h-64' : ''}`}>
//                                                         {item.items.map((subItem) => (
//                                                             <li key={subItem.title}><Link to={subItem.path} className="block px-3 py-2 text-sm text-gray-600 hover:bg-header-primary/10 hover:text-header-primary rounded-md whitespace-nowrap" onClick={closeAllMenus}>{subItem.title}</Link></li>
//                                                         ))}
//                                                     </ul>
//                                                 </div>
//                                             </div>
//                                         </>
//                                     ) : (
//                                         <Link to={item.path} className={`flex items-center px-4 h-full text-sm font-semibold uppercase transition-colors 
//                                             ${item.title === 'ACCREDITATION' ? 'text-brand-red hover:text-brand-red' : 'text-gray-700 hover:text-header-primary'}`}>
//                                             {item.title}
//                                         </Link>
//                                     )}
//                                 </li>
//                             );
//                         })}
//                         <li className="ml-4">
//                             {/* FIX 2: BUTTON TEXT WRAPPING SOLVED */}
//                             <Link to="/admissions/apply-now" className="bg-[#9E1F24] hover:bg-[#87191E] !text-white text-sm font-bold py-2.5 px-5 rounded-md transition-colors shadow-sm hover:shadow-md whitespace-nowrap" style={{ backgroundColor: '#9E1F24', color: 'white !important' }}>
//                                 APPLY NOW
//                             </Link>
//                         </li>
//                     </ul>
//                 </nav>
                
//                 <button className="lg:hidden text-2xl text-gray-800" onClick={toggleMenu} aria-label="Open menu"><FaBars /></button>
//             </div>
//         </div>
//       </div>
      
//       {/* Mobile Menu Panel */}
//       <div className={`fixed top-0 right-0 w-80 max-w-[85%] h-full bg-white shadow-2xl z-[100] transition-transform duration-300 ease-in-out lg:hidden ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
//         <div className="flex justify-between items-center p-4 border-b">
//           <Logo />
//           <button onClick={toggleMenu} className="text-2xl text-gray-600 p-2"><FaTimes /></button>
//         </div>
//         <nav className="p-4 overflow-y-auto h-[calc(100vh-70px)]">
//           <ul>
//             {menuItems.map((item) => (
//               <li key={item.title} className="border-b border-gray-200">
//                 {item.dropdown ? (
//                   <div>
//                     <button onClick={(e) => toggleDropdown(e, item.title)} className="w-full flex justify-between items-center py-3.5 text-left font-semibold text-gray-800">
//                       <span>{item.title}</span>
//                       <span className={`transition-transform duration-300 ${openDropdown === item.title ? 'rotate-180' : ''}`}><FaChevronDown className="h-3 w-3" /></span>
//                     </button>
//                     <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openDropdown === item.title ? 'max-h-[600px]' : 'max-h-0'}`}>
//                       <ul className="pl-4 pt-1 pb-3">
//                         {item.items.map((subItem) => (
//                           <li key={subItem.title}><Link to={subItem.path} onClick={() => handleItemClick(subItem.path)} className="block py-2 text-sm text-gray-600 hover:text-header-primary">{subItem.title}</Link></li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 ) : (
//                    <Link to={item.path} onClick={closeAllMenus} className={`w-full block py-3.5 font-semibold 
//                     ${item.title === 'APPLY NOW' ? '!bg-[#9E1F24] hover:!bg-[#87191E] !text-white text-center rounded-lg my-4 shadow-md' : ''}
//                     ${item.title === 'ACCREDITATION' ? 'text-brand-red' : ''}
//                     ${item.title !== 'APPLY NOW' ? 'text-gray-800' : ''}`}>
//                     {item.title}
//                   </Link>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </nav>
//       </div>
//       {isMenuOpen && <div onClick={toggleMenu} className="fixed inset-0 bg-black/50 z-50 lg:hidden"></div>}
//     </header>
//   );
// };

import React, { useState, useEffect, useRef } from 'react';
import { FaPhoneAlt, FaMapMarkerAlt, FaUser, FaTimes, FaBars, FaChevronDown, FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../Logo/Logo'; // Make sure your Logo component works well on a dark background

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const headerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Your original menu items
  const menuItems = [
    { title: 'HOME', path: '/' },
    { title: 'ABOUT', path: '/about' },
    { title: 'ACADEMICS', path: '/academics' },
    { title: 'UNIVERSITY PROGRESSION', path: '/university-progression' },
    { 
      title: 'Our CAMPUS', 
      path: '/online-campus',
      dropdown: true,
      items: [
        { title: 'Online Verification', path: '/online-campus/verification' },
        { title: 'Smart Learning', path: '/online-campus/smart-learning' },
        { title: 'Accreditation', path: '/online-campus/accreditation' },
      ]
    },
    { title: 'CENTERS', path: '/centers' },
    { title: 'CONTACT', path: '/contact' },
  ];

  const applyNowItem = { title: 'APPLY NOW', path: '/admissions/apply-now' };

  // Your original functions for state management
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeAllMenus = () => { setIsMenuOpen(false); setOpenDropdown(null); };
  const handleItemClick = (path) => { navigate(path); closeAllMenus(); };
  const toggleDropdown = (e, menuTitle) => { e.preventDefault(); setOpenDropdown(openDropdown === menuTitle ? null : menuTitle); };

  useEffect(() => { closeAllMenus(); }, [location.pathname]);
  useEffect(() => { const handleClickOutside = (event) => { if (headerRef.current && !headerRef.current.contains(event.target)) closeAllMenus(); }; document.addEventListener('mousedown', handleClickOutside); return () => document.removeEventListener('mousedown', handleClickOutside); }, []);
  useEffect(() => { document.body.style.overflow = isMenuOpen ? 'hidden' : 'unset'; return () => { document.body.style.overflow = 'unset'; }; }, [isMenuOpen]);

  return (
    <header ref={headerRef} className="w-full  text-white  z-50 sticky top-0 ">

      {/* === TOP BAR (YELLOW DESIGN) === */}
      <div className="bg-red-900 text-white text-sm">
        <div className="container mx-auto px-4">
            <div className="flex justify-between items-center py-2 flex-wrap gap-x-6 gap-y-2">
                <div className="flex items-center gap-4 flex-wrap">
                    <a href="tel:+442081234567" className="flex items-center gap-2 hover:text-gray-700 transition-colors">
                        <FaPhoneAlt />
                        <span>+923008744261</span>
                    </a>
                    <div className="hidden sm:flex items-center gap-2">
                        <FaMapMarkerAlt />
                        <span>2nd Floor, FIC Plaza, Bahria Town Phase 7, Islamabad</span>
                    </div>
                </div>
                <div className="flex items-center gap-5">
                    <div className="flex items-center gap-3 text-base">
                      <a href="https://www.facebook.com/" aria-label="Facebook" className="hover:text-gray-700" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                      <a href="https://www.linkedin.com/" aria-label="LinkedIn" className="hover:text-gray-700" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/ficgroupedu/" aria-label="Instagram" className="hover:text-gray-700" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                      <a href="https://twitter.com/" aria-label="Twitter" className="hover:text-gray-700" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
                    </div>
                    {/* FIX 1: Login link 'hidden md:flex' se 'flex' kar diya hai taaki hamesha dikhe */}
                    <div className="flex items-center gap-2.5 text-sm">
                        <Link to="/login" className="flex items-center gap-1.5 hover:text-gray-700 transition-colors font-semibold">
                            <FaUser /><span className=''>Login</span>
                        </Link>
                    </div>
                    <div className="flex items-center gap-2.5 text-sm">
                        <Link to="/register" className="flex items-center gap-1.5 hover:text-gray-700 transition-colors font-semibold">
                            <FaUser /><span className=''>Register</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
      </div>

      {/* === MAIN HEADER (DARK DESIGN WITH FIXES) === */}
      <div className="bg-white text-black">
        <div className="container mx-auto px-4 flex justify-between items-center h-20">
            <Link to="/" onClick={closeAllMenus} className="flex-shrink-0">
                <Logo />
            </Link>
            <nav className="hidden lg:flex items-center h-full">
                {/* FIX 2: whitespace-nowrap aur padding adjust ki hai */}
                <ul className="flex items-center h-full gap-1 whitespace-nowrap">
                    {menuItems.map((item) => (
                        <li key={item.title} className="group relative h-full flex items-center">
                            {item.dropdown ? (
                                <>
                                    <Link to={item.path} className="flex items-center gap-2 px-2.5 h-full text-xs font-bold uppercase tracking-wider text-black hover:text-[#fdb913] transition-colors">
                                        {item.title}
                                        <FaChevronDown className="h-2 w-2 transition-transform group-hover:rotate-180" />
                                    </Link>
                                    <div className="absolute top-full left-0 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 w-64">
                                        <div className="bg-white text-black shadow-2xl rounded-md border border-gray-200">
                                            <ul className={`p-2 overflow-y-auto scrollbar-hide ${item.title === 'ACADEMICS' ? 'max-h-80' : ''}`}>
                                                {item.items.map((subItem) => (
                                                    <li key={subItem.title}>
                                                        <Link to={subItem.path} className="block w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-black rounded-md whitespace-nowrap" onClick={closeAllMenus}>{subItem.title}</Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <Link to={item.path} className="flex items-center px-2.5 h-full text-xs font-bold uppercase tracking-wider text-black hover:text-red-900 transition-colors">
                                    {item.title}
                                </Link>
                            )}
                        </li>
                    ))}
                    <li className="ml-3">
                        <Link to={applyNowItem.path} className="bg-red-900 hover:bg-red-900 text-white text-xs font-bold py-3 px-5 rounded-sm transition-colors whitespace-nowrap">
                            {applyNowItem.title}
                        </Link>
                    </li>
                </ul>
            </nav>
            <button className="lg:hidden text-2xl text-white" onClick={toggleMenu} aria-label="Open menu"><FaBars /></button>
        </div>
      </div>
      
      {/* === MOBILE MENU PANEL (DARK DESIGN) === */}
      <div className={`fixed top-0 right-0 w-80 max-w-[85%] h-full bg-[#222222] shadow-2xl z-[100] transition-transform duration-300 ease-in-out lg:hidden ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex justify-between items-center p-4 border-b border-gray-700 h-20">
          <Logo />
          <button onClick={toggleMenu} className="text-2xl text-gray-400 p-2"><FaTimes /></button>
        </div>
        <nav className="p-4 overflow-y-auto h-[calc(100vh-80px)]">
          <ul>
            {[...menuItems, applyNowItem].map((item) => (
              <li key={item.title} className="border-b border-gray-700">
                {item.dropdown ? (
                  <div>
                    <button onClick={(e) => toggleDropdown(e, item.title)} className="w-full flex justify-between items-center py-3.5 text-left font-semibold text-white">
                      <span>{item.title}</span>
                      <span className={`transition-transform duration-300 ${openDropdown === item.title ? 'rotate-180' : ''}`}><FaChevronDown className="h-3 w-3" /></span>
                    </button>
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out bg-black/20 ${openDropdown === item.title ? 'max-h-[600px]' : 'max-h-0'}`}>
                      <ul className="pl-4 pt-1 pb-3">
                        {item.items.map((subItem) => (
                          <li key={subItem.title}><Link to={subItem.path} onClick={() => handleItemClick(subItem.path)} className="block py-2 text-sm text-gray-300 hover:text-[#fdb913]">{subItem.title}</Link></li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : (
                   <Link to={item.path} onClick={closeAllMenus} className={`w-full block py-3.5 font-semibold 
                    ${item.title === 'APPLY NOW' ? '!bg-red-900 hover:!bg-red-700 !text-black text-center rounded-md my-4 shadow-md' : 'text-white hover:text-red-900'}`}>
                    {item.title}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      {isMenuOpen && <div onClick={toggleMenu} className="fixed inset-0 bg-black/60 z-50 lg:hidden"></div>}
    </header>
  );
};

export default Header;